import { atom } from "recoil";

export const productTestState = atom({
  key: "productTestState",
  default: {},
});
